<script lang="ts" setup>
import { NOOP } from "@vue/shared";
import { getActivePinia } from "pinia";
import { inject, onUnmounted, toRef } from "vue";
import { usePrescriptionStore } from "../../../../store/transitient/prescription";
import { parseRoute } from "../../../../utils/route";
import CreatePrescriptionForm from "../CreatePrescriptionForm";
import PrescriptionScreen from "../PrescriptionScreen";

const parsed = parseRoute(inject("drawer-url"));
const prescriptionId = parsed.id!;

// end

const props = defineProps<{
  openIssue?: boolean;

  contextId?: string;
  contextType?: string;
  success?: Function;
  afterSuccess?: Function;
  showIssueLaterButton?: boolean;
  issueLaterLabel?: string;
  issueLaterColor?: string;
  hideIssueNow?: boolean;
  workflowIdentifier?: string;
  skipIssuing?: boolean;
  taskId?: string;
  taskType?: string;

  modalTitle?: string;
  action?: string;
  formUrl?: string;
}>();

defineEmits({
  success: () => true,
});
const setTitle = inject<(v: string) => void>("setTitle", NOOP);
setTitle(props.modalTitle ?? "New Prescription");

// init
const store = usePrescriptionStore();
await store.initById(prescriptionId, props.action ?? "indeterminate");

store.form.contextId =
  parsed.query.contextId ||
  (toRef(
    props,
    "contextId",
  ) as any) /* this type is correct, just typescript does not support this ATM*/;

store.form.contextType =
  parsed.query.contextType ||
  (toRef(
    props,
    "contextType",
  ) as any) /* this type is correct, just typescript does not support this ATM*/;

if (props.taskId && props.taskType) {
  store.form.taskId = props.taskId;
  store.form.taskType = props.taskType;
}

if (parsed.query.workflowIdentifier) {
  store.form.workflowIdentifier = parsed.query.workflowIdentifier;
}

store.state.skipIssuing = parsed.query.skipIssuing || (toRef(props, "skipIssuing") as any);

store.form.action = "indeterminate";

const formUrl = props.formUrl ?? "/clinical/prescription/prescribe-again";
const afterSuccess = props.afterSuccess ?? null;

onUnmounted(() => {
  // clean store
  store.$dispose();

  // clear store state
  const pinia = getActivePinia();
  delete pinia!.state.value[store.$id];
});
// / init
</script>
<template>
  <PrescriptionScreen>
    <CreatePrescriptionForm
      :form-url="formUrl"
      hide-add-another
      :hide-issue-now="hideIssueNow"
      :show-issue-later-button="showIssueLaterButton"
      :issue-later-label="issueLaterLabel"
      :issue-later-color="issueLaterColor"
      :after-success="afterSuccess"
      @success="success"
    />
  </PrescriptionScreen>
</template>
